export const filter =
    {
        user: {
            userId: null,
            name: null,
            lastName: null,
            username: null,
            email: null
        },
    }
;